import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  LoadingIconModule,
  SmartadminModule,
  SmartadminWizardsModule,
  SmartadminDatatableModule,
  SmartadminValidationModule,
  SmartadminInputModule,
  SharedAngularComponentsAvlaModule,
  AuthElementsModule,
} from 'shared-angular-components-avla';
import {
  CommonsGenericTableAvlaModule,
  GenericTableAvlaModule,
} from 'generic_table_avla_front_components';
import { ReactiveFormsModule } from '@angular/forms';
// import { TextMaskModule } from 'angular2-text-mask';
import { routing } from './list-archivos.routing';
import { FormsModule } from '@angular/forms';
import { Select2Module } from 'shared-angular-components-avla/shared/forms/input/select2/select2.module';
import { RetryNotificationMessageService } from 'base-angular-avla';
import { ListArchivosComponent } from './list-archivos.component';

@NgModule({
  imports: [
    CommonModule,
    SmartadminModule,
    SmartadminWizardsModule,
    SmartadminDatatableModule,
    SmartadminValidationModule,
    SmartadminInputModule,
    LoadingIconModule,
    AuthElementsModule,
    ReactiveFormsModule,
    GenericTableAvlaModule,
    CommonsGenericTableAvlaModule,
    SharedAngularComponentsAvlaModule.forRoot(),
    Select2Module,
    routing,
    FormsModule,
  ],
  declarations: [ListArchivosComponent],
  exports: [ListArchivosComponent],
  providers: [RetryNotificationMessageService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ListArchivosModule {}
